import childrenFilter from '@/translation/pl/childrenFilter.json'
import childrenList from '@/translation/pl/childrenList.json'
import childPage from '@/translation/pl/childPage.json'
import donorForm from '@/translation/pl/donorForm.json'
import form from '@/translation/pl/form.json'
import home from '@/translation/pl/home.json'
import footer from '@/translation/pl/footer.json'
import errorsPages from '@/translation/pl/errorsPages.json'
import closed from '@/translation/pl/closed.json'
import faq from '@/translation/pl/faq.json'

export default {
  ...childrenFilter,
  ...childrenList,
  ...childPage,
  ...donorForm,
  ...form,
  ...home,
  ...footer,
  ...errorsPages,
  ...closed,
  ...faq
}
